import React, { Component } from 'react';
import onEnterPressed from '@shootsta/on-enter-pressed';
import cx from 'classnames';
import _memoize from 'lodash.memoize';

import { EditorState, convertFromRaw } from 'draft-js';
import { Checkbox, Icon, Text, Button } from '../../../../../ui-kit';

import ContentLoader from '../../../../ContentLoader';
import { checkResourceOwner } from '../../../utils';
import { getUser } from '../../../../../common/utils';
import Replies from '../../../common/Replies';
import AddReply from '../../CommentPopover/components/EditCommentPopover/components/AddReply';
import CommentBody from './CommentBody';
import CommentFooter from './CommentFooter';
import CommentV2 from './CommentV2';
import { COMMENT_VISIBILITY_STYLES } from '../../../constants/commentVisibilityStyles';

import '../styles/_comment.scss';

const VISIBILITY_LABELS = {
  PUBLIC: 'Public',
  INTERNAL: 'Internal',
  SHOOTSTA_INTERNAL: 'Shootsta Internal'
};


















































const onUpdateCheckbox = _memoize(
  ({ commentId, isResolved, updateComment }) => (event) => {
    if (event) {
      event.stopPropagation();
    }

    updateComment(
      commentId, {
        disableNotifications: true,
        isResolved: !isResolved
      });
  }
);

const handleEditComment = _memoize(
  ({
    commentId,
    showEditCommentModal



  }) => (event) => {
    if (event) {
      event.stopPropagation();
    }

    showEditCommentModal({ commentId, editMode: true });
  }
);

const handleDelete = _memoize(
  ({
    commentId,
    deleteComment



  }) => async (event) => {
    if (event) {
      event.stopPropagation();
    }

    deleteComment({ commentId });
  }
);

const handleDeleteReply = _memoize(
  ({
    commentId,
    parentComment,
    deleteReply




  }) => () => {
    deleteReply({ commentId, parentComment });
  }
);

const resetEditorState = () => EditorState.createEmpty();
export default class CommentComponent extends Component


{
  handleEditReply = _memoize(
    ({ replyComment }) => () => {
      const { commentId, content } = replyComment;

      if (content && commentId) {
        const contentState = convertFromRaw(content);
        const editorState = EditorState.createWithContent(contentState);

        this.setState({
          replyCommentIdToEdit: commentId,
          updateEditorState: editorState
        });
      }
    }
  );

  constructor(props) {
    super(props);

    this.state = {
      showAddReplyForm: false,
      editorState: resetEditorState(),
      updateEditorState: resetEditorState(),
      replyCommentIdToEdit: ''
    };
  }

  handleClickReply = (event) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({ showAddReplyForm: true });
  };

  resetEditForm = () => {
    this.setState({ replyCommentIdToEdit: '' });
  };

  render() {
    const {
      commentIndex,
      commentOrderByTimeline,
      comment,
      comment: {
        commentId,
        content,
        createdByUser,
        updatedAt,
        children: replies = [],
        isResolved,
        fetching,
        assetIds,
        resourceId,
        metadata,
        number
      },
      canResolveComment,
      getUserColor,
      updateComment,
      getCommentTitle,
      getSceneLabel,
      isGroupSelected,
      isCommentSelected,
      onSelectComment,
      deleteComment,
      editReply,
      deleteReply,
      createReply,
      isReadOnlyMode,
      resourceOwnerUserId,
      showReplyCommentForm,
      onInputFocus,
      showEditCommentModal,
      isV2Design = false,
      allowedWriteVisibilityOptions = [],
      isStoryboard
    } = this.props;

    if (fetching) {
      return (
        <div className="comment">
          <ContentLoader darkTheme>
            <rect x="0" y="10" rx="4" ry="4" width="400" height="15" />
            <rect x="0" y="50" rx="3" ry="3" width="400" height="12" />
            <rect x="0" y="73" rx="3" ry="3" width="400" height="12" />
            <rect x="0" y="100" rx="15" ry="15" width="32" height="32" />
            <rect x="40" y="110" rx="3" ry="3" width="360" height="12" />
          </ContentLoader>
        </div>);

    }

    const {
      editorState,
      showAddReplyForm,
      updateEditorState,
      replyCommentIdToEdit
    } = this.state;

    const { isAddedByCommentForm = false, visibility } = JSON.parse(metadata || '{}');

    const commentTitle = getCommentTitle ? getCommentTitle(comment) : '';
    const visibilityStyle = visibility && COMMENT_VISIBILITY_STYLES[visibility];
    const visibilityLabel = VISIBILITY_LABELS[visibility];

    const user = getUser(createdByUser);

    const { color, brightness } = getUserColor({ userId: user.userId });

    const isResourceOwner = checkResourceOwner(resourceOwnerUserId);

    const isDeletable = (user.isUser || isResourceOwner) && !isReadOnlyMode;

    const isEditable = (user.isUser || isResourceOwner) && !isReadOnlyMode && onSelectComment;

    const shouldShowReplyCommentForm = showReplyCommentForm && !isReadOnlyMode;

    const isShowAddReplyForm = shouldShowReplyCommentForm && showAddReplyForm;

    if (isV2Design) {
      return (
        <div className={cx({ 'border-t': number && number > 1 && isStoryboard })}>
          <CommentV2
            {...this.props}
            {...this.state}
            user={user}
            allowedWriteVisibilityOptions={allowedWriteVisibilityOptions}
            color={color}
            brightness={brightness}
            isResourceOwner={isResourceOwner}
            isDeletable={isDeletable}
            isEditable={isEditable}
            isShowAddReplyForm={shouldShowReplyCommentForm}
            handleClickReply={this.handleClickReply}
            resetEditForm={this.resetEditForm}
            onUpdateCheckbox={onUpdateCheckbox}
            handleDelete={handleDelete}
            handleDeleteReply={handleDeleteReply} />

        </div>);

    }

    return (
      <>
        <div
          role="button"
          onClick={isAddedByCommentForm ? null : onSelectComment}
          onKeyPress={
          shouldShowReplyCommentForm ?
          null :
          onEnterPressed({ onClick: onSelectComment })}

          tabIndex={commentIndex}
          className={cx(
            // 'bg-white !border !border-[#E6E8EB] !rounded-2xl shadow-sm !p-6 !mt-4 hover:!bg-white',
            'comment !p-3',
            { 'comment--group-selected': isGroupSelected },
            { 'comment--comment-selected': isCommentSelected }
          )}>

          <div className="comment__upper-container">
            <div className="comment__upper-container__heading">
              <div className="comment__upper-container__heading__left">
                {commentOrderByTimeline &&
                <div
                  className="comment__upper-container__heading__left__number !w-7 !h-7"
                  style={{ backgroundColor: color, filter: brightness }}>

                    <Text button darkTheme noMargin>
                      {commentOrderByTimeline}
                    </Text>
                  </div>}

                <Text
                  heading4
                  noMargin
                  className="comment__upper-container__heading__left__title !text-lg !font-bold !text-[#1F2A37]">

                  {getSceneLabel && getSceneLabel(comment)}
                </Text>
              </div>
              {assetIds.length ?
              <div className="comment__upper-container__heading__right__attachments">
                  <Text noMargin label>
                    {assetIds.length}
                  </Text>
                  <Icon name="attachment" size={15} />
                </div> :
              null}
              <div className="comment__upper-container__heading__right">
                {canResolveComment ?
                <Checkbox
                  checked={isResolved}
                  onChange={onUpdateCheckbox({
                    commentId,
                    isResolved,
                    updateComment
                  })} /> :

                null}
              </div>
              {isEditable ?
              <Button
                type="TERTIARY"
                prefix="edit"
                className="comment__upper-container__heading__right"
                prefixSize={20}
                onClick={handleEditComment({
                  commentId,
                  showEditCommentModal
                })} /> :

              null}

              {isDeletable ?
              <Button
                type="TERTIARY"
                prefix="trash"
                prefixSize={20}
                onClick={handleDelete({ commentId, deleteComment })} /> :

              null}
            </div>
            <CommentBody content={content} />

            <div className="flex items-center gap-2 mt-4">
              {commentTitle &&
                <span className="shrink-0 rounded px-2 py-1 text-xs font-bold bg-[#F8F1D6] text-[#6F6866]">
                    {commentTitle}
                  </span>}

              { visibilityStyle && visibilityLabel &&
                <span className="shrink-0 flex items-center gap-1.5 rounded px-2 py-1 text-xs font-bold bg-[#F8F1D6] text-[#6F6866]">
                    <Icon name={visibilityStyle.icon} size={14} />
                    {visibilityLabel}
                  </span>}
            </div>

          </div>

          <div className="mt-4 border-t border-[#E6E8EB]">
          <CommentFooter
            user={user}
            updatedAt={updatedAt}
            handleClickReply={
            shouldShowReplyCommentForm ? this.handleClickReply : undefined} />
          </div>


          {isShowAddReplyForm &&
          <div>
              <AddReply
              visible={isShowAddReplyForm}
              createReply={createReply}
              comment={comment}
              onUpdateContent={(newEditorState) => {
                this.setState({ editorState: newEditorState });
              }}
              editorState={editorState}
              clearInput={() => {
                this.setState({ editorState: resetEditorState() });
              }}
              resourceOrganisationId={resourceId}
              onInputFocus={onInputFocus} />

            </div>}

        </div>

        <Replies
          parentComment={comment}
          updateEditorState={updateEditorState}
          commentIdToEdit={replyCommentIdToEdit || void 0}
          deleteReply={deleteReply}
          editReply={editReply}
          replies={replies}
          handleEdit={!isReadOnlyMode ? this.handleEditReply : null}
          handleDelete={!isReadOnlyMode ? handleDeleteReply : null}
          clearInput={this.resetEditForm}
          resourceId={resourceId}
          isResourceOwner={isResourceOwner}
          onUpdateContent={(newEditorState) => {
            this.setState({ updateEditorState: newEditorState });
          }} />

      </>);

  }
}